module.exports = __webpack_public_path__ + "static/media/photo1.82174557.jpeg";